// Display only: some contacts already include locality details in streetAddress.
export function contactAddress(contact = {}) {
  const seen = new Set();
  return [contact.streetAddress, contact.city, contact.state, contact.country, contact.zipCode]
    .flatMap(value => typeof value === "string" || typeof value === "number" ? String(value).split(",") : [])
    .map(part => part.trim())
    .filter(part => {
      const key = part.toLocaleLowerCase("en-AU").replace(/\s+/g, " ");
      if (!key || /^[a-f0-9]{24}$/i.test(part) || seen.has(key)) return false;
      seen.add(key);
      return true;
    })
    .join(", ");
}
